/**
 * Enum representing payment plan intervals.
 */
export enum PaymentPlanInterval {
  Weekly = 1,
  BiWeekly = 2,
  Monthly = 3
}

/**
 * Gets the i18n key for the payment plan interval.
 * @param interval The payment plan interval.
 * @returns The i18n key for the payment plan interval.
 */
export function getPaymentPlanIntervalI18nKey(interval: PaymentPlanInterval): string {
  switch (interval) {
    case PaymentPlanInterval.Weekly:
      return 'PAYMENT_PLAN_INTERVAL_WEEKLY'
    case PaymentPlanInterval.BiWeekly:
      return 'PAYMENT_PLAN_INTERVAL_BI_WEEKLY'
    case PaymentPlanInterval.Monthly:
      return 'PAYMENT_PLAN_INTERVAL_MONTHLY'
    default:
      return ''
  }
}
